export default __webpack_public_path__ + "static/media/product-image-1.a75fa6bf.jpg";